import {
    $,
    $$,
    createElement,
    createSpinner,
    empty,
    getParentElementByClassName,
    getParentElementByTagName,
    html_chargement_en_cours,
    show,
    createIcon, hide,
} from "./Dom.ts";
import {$get, $postForm, ajaxResponse} from "./Ajax.ts";
import {animateLoadingButton, fadeIn, fadeOut, fadeOutFadeIn} from "./Animate.ts";
import {initSelects, selectValue} from "./Select.ts";
import {initTooltips} from "./Tooltip.ts";
import {generateModale, hideModal, initHistoryModal} from "./Modal.ts";
import {debounce} from "lodash-es";
import {stopPropagation} from "./Event.ts";
import type {OptionOptional} from "slim-select/dist/store";
import {initAddServiceModal} from "../../structure/js/AdministrationDesServices.ts";

type ISelecteurOptions = {
    selecteurs: {
        departementSelectId: string
        categoriesList: string
        categorieElements: string
        selectedCategorieElements: string
        noResult: string
        searchService: string
        containerListService: string
        listService: string
        // afficherSousService: string
        sendMultiple: string
        toutdeplier: string
        toutSelectionner: string
    },
    urls: {
        [key: string]: string
    }
    action: string | undefined
    secteur: string | undefined
    categorie: string | undefined
    ajout: string | undefined
    object_id: string | undefined
    show_old: boolean
    selecteur_multiple: boolean
    show_agent: boolean
    show_sous_service: boolean
    manif: string | undefined
    avertissement: string | undefined
    selecteur_id_reference: string | undefined
}

type ISelecteurListOptions = {
    object_id: string | undefined
    action: string | undefined
    show_agent: boolean | undefined
    show_old: boolean | undefined
    show_sous_service: boolean | undefined
    manif: string | undefined
}
type ISelecteurCategorieOptions = {
    action: string | undefined
    ajout: string | undefined
    object_id: string | undefined
}

type IService = {
    id: number,
    name: string,
    data?: any,
    service?: string,
    smtp_error?: boolean,
    actif?: boolean,
    has_children?: boolean,
    deja_fait?: boolean
    agents_count?: {
        cdsr?: number,
        agents_actif?: number,
        agents_inactif?: number
    },
    icones?: IServiceIcones
}

type IServiceIcones = {
    admin_service_famille_b: boolean
    admin_utilisateurs_subalternes_b: boolean
    autorise_acces_consult_organisateur_b: boolean
    autorise_interroge_preavis_famille_b: boolean
    autorise_mandater_avis_famille_b: boolean
    autorise_rendre_avis_b: boolean
    autorise_rendre_preavis_a_service_avis_b: boolean
    porte_entree_avis_b: boolean
}

export class SelecteurDeServices extends EventTarget {
    private _options: ISelecteurOptions = {
        selecteurs: {
            departementSelectId: '.select-instances-modal',
            categoriesList: '.modal-categorie-selecteur',
            categorieElements: '.categorie',
            selectedCategorieElements: '.categorie.selected',
            containerListService: '.selecteur-list',
            noResult: '.no-result',
            searchService: '.service-search',
            listService: '.service-liste',
            sendMultiple: ".send_multiple",
            toutdeplier: ".container_tout_deplier",
            toutSelectionner: ".select-all-button",
        },
        urls: {},
        action: undefined,
        secteur: undefined,
        categorie: undefined,
        ajout: undefined,
        object_id: undefined,
        show_old: false,
        selecteur_multiple: false,
        show_agent: false,
        show_sous_service: false,
        manif: undefined,
        avertissement: undefined,
        selecteur_id_reference: undefined,
    }

    private _categorie: string | undefined;
    private _secteur: string | undefined;
    private value_array: OptionOptional[] = [];
    private badge_array: any = {};
    private tout_deplier = false;
    private demande_envoye = false;

    constructor(options: Partial<ISelecteurOptions>) {
        super();
        this.init(options);
    }

    private init(options: Partial<ISelecteurOptions>): void {
        empty($<HTMLElement>(this._options.selecteurs.listService));
        this.initExpand();
        this._options = { ...this._options, ...options };
        this.setSelecteurReferences();
        this.updateSelectors();
        this.initState();
        this.initListeners();
        this.renderListCategorie({
            action: this._options.action,
            ajout: this._options.ajout,
            object_id: this._options.object_id,
        });
        this.showCategorieListIfSecteur();
    }

    get demandeEnvoyer() {
        return this.demande_envoye;
    }

    get categorie(): string | undefined {
        return this._categorie;
    }

    get secteur(): string | undefined {
        return this._secteur;
    }

    get options(): ISelecteurOptions {
        return this._options;
    }

    private setSelecteurReferences(): void {
        const { action, ajout } = this._options;
        this._options.selecteur_id_reference = `#selecteur-service-${action}-contenair`;
        if (action === "consultation") {
            this._options.selecteur_id_reference = `#selecteur-service-${action}-${ajout}-contenair`;
        }
    }

    private updateSelectors(): void {
        const selecteur_action_reference = `#${this._options.action}${this._options.action === "consultation" ? `-${this._options.ajout}` : ''}`;
        for (const key in this._options.selecteurs) {
            this._options.selecteurs[key] = `${this._options.selecteur_id_reference} ${this._options.selecteurs[key]}`;
        }
        this._options.selecteurs.sendMultiple = `${selecteur_action_reference} .send_multiple`;
        this._options.selecteurs.toutSelectionner = `${selecteur_action_reference} .select-all-button`;
    }

    private initExpand(): void {
        const isPage = $("#administration-services-container");
        if (isPage) {
            const toggleExpand = $('#expand-selecteur-service');
            show(toggleExpand);
            toggleExpand?.addEventListener('click', () => {
                const main = $("main.fr-container");
                if (main) main.classList.replace('fr-container', 'fr-container-fluid');
                else $("main.fr-container-fluid")?.classList.replace('fr-container-fluid', 'fr-container');
            });
        }
    }

    private initState(): void {
        if (!this._options.selecteur_multiple) {
            fadeOut($(this._options.selecteurs.sendMultiple));
            fadeOut($(this._options.selecteurs.toutSelectionner));
        }
        const secteurInput = $<HTMLInputElement>(this._options.selecteurs.departementSelectId);
        this._secteur = secteurInput?.value || this._options.secteur;
        if (this._options.secteur && secteurInput) {
            selectValue(this._options.selecteurs.departementSelectId, this._options.secteur);
            secteurInput.value = this._options.secteur;
        }
        const selectedCategories = $$<HTMLElement>(this._options.selecteurs.selectedCategorieElements);
        if (selectedCategories.length > 0) {
            this._categorie = selectedCategories[0].dataset?.categorie;
        }
        if (this.options.action === "demande_avis") {
            hide($('.selecteur-header'));
        } else {
            show($('.selecteur-header'));
        }
    }

    private initListeners(): void {
        $<HTMLSelectElement>(this._options.selecteurs.departementSelectId)?.addEventListener('change', this.handleUpdateSecteur.bind(this));
        $<HTMLSelectElement>(this._options.selecteurs.toutdeplier)?.addEventListener('click', this.handleToutDeplier.bind(this));
        $<HTMLInputElement>(this._options.selecteurs.searchService)?.addEventListener('input', debounce(this.handleSearchUpdate.bind(this), 300));
        $<HTMLInputElement>(this._options.selecteurs.searchService)?.addEventListener('focus', this.handleSearchFocus.bind(this));
        $<HTMLButtonElement>(this._options.selecteurs.toutSelectionner)?.addEventListener('click', this.handleSelectionnerTout.bind(this));
        $<HTMLButtonElement>(this._options.selecteurs.sendMultiple)?.addEventListener('click', this.handleSubmitData.bind(this));
    }

    private initCategoriesListeners(): void {
        $$<HTMLSelectElement>(this._options.selecteurs.categorieElements).forEach(categorie => categorie.addEventListener('click', this.handleCategorieClick.bind(this)));
    }

    private showCategorieListIfSecteur(): void {
        if (this._options.secteur) {
            show($<HTMLElement>(this._options.selecteurs.categoriesList));
        }
    }

    private renderListCategorie(parametres: ISelecteurCategorieOptions) {
        if (this._secteur) {
            $get(window.Openscop.url_categorie_list, {
                'action': parametres.action,
                'acces': parametres.ajout,
                'object_pk': parametres.object_id,
                'secteur': this._secteur,
            }).then(response => {
                const data = JSON.parse(response.body)
                const categorieList = $(this._options.selecteurs.categoriesList)
                if (categorieList && this._secteur) {
                    empty(categorieList)
                    data.forEach(element => {
                        const li = createElement('li', ['categorie']);
                        li.dataset.categorie = element[0];
                        li.innerText = element[1];
                        categorieList.appendChild(li);
                        if (this._options.selecteur_multiple) {
                            this.renderCategorieBadge(this._secteur, element[0]);
                        }
                    });
                    fadeIn(categorieList)
                    this.initCategoriesListeners()
                    if (this._categorie) {
                        const selectedCategory = $(`${this._options.selecteur_id_reference} .categorie[data-categorie="${this._categorie}"]`);
                        selectedCategory?.click();
                    }
                }
            })
        }
    }

    private renderService(service: IService, secteur: string, category: string, is_admin: boolean = false): HTMLElement {
        // Déterminer si le service a des sous-services
        let has_children = service.hasOwnProperty('has_children') ? service?.has_children ?? false : false;
        if (service?.data?.length > 0) has_children = true;

        // Créer l'élément section de l'accordéon
        const section = createElement('section', ['fr-accordion']);
        section.dataset.service = String(service.id);
        section.dataset.secteur = secteur;
        section.dataset.categorie = category;

        // Créer le titre de l'accordéon
        const title = createElement('h3', ['fr-accordion__title']);
        const titleBtn = this.renderServiceButton(service, is_admin, has_children);
        title.appendChild(titleBtn);
        section.appendChild(title);

        // Créer le bloc de label pour le service
        const labelBlock = this.renderServiceLabel(service);

        // Si le service a des sous-services, créer l'élément de conteneur pour ceux-ci
        if (has_children) {
            const sousService = createElement('div', ['fr-collapse']);
            sousService.id = `liste_sous_service_${service.id}`;
            section.appendChild(sousService);

            if (this._options.show_sous_service) {
                // Si l'option show_sous_service est activée, afficher les sous-services
                if (service.data.length > 0) {
                    for (let sous_service of service.data) {
                        sousService.appendChild(this.renderService(sous_service, secteur, category, is_admin));
                    }
                }
            } else {
                // Sinon, afficher le message de chargement
                sousService.appendChild(html_chargement_en_cours());
            }
        }

        // Si show_sous_service ou tout_deplier est activé, ouvrir l'accordéon après un délai
        if (this._options.show_sous_service || this.tout_deplier) {
            setTimeout(() => titleBtn.click(), 0);
        }

        titleBtn.appendChild(labelBlock);

        // Ajouter les boutons d'action si les conditions sont remplies
        if (this.shouldAddActionButtons()) {
            const actionBlock = createElement("div", ['service-actions']);
            actionBlock.id = `button_span_${service.id}`;
            actionBlock.dataset.test = service.name;

            const actionBtn = this.createBtn(service);
            actionBtn.addEventListener('click', this.handleActionBtnClick.bind(this));
            actionBlock.appendChild(actionBtn);
            titleBtn.appendChild(actionBlock);
        }
        initTooltips(section);
        return section;
    }

    // Méthode pour vérifier les conditions d'ajout des boutons d'action
    private shouldAddActionButtons(): boolean {
        const actions = ["administration", "demande_avis", "consultation"];
        return (this._options.urls.url_selecteur_action !== "" || this._options.show_sous_service) &&
            !actions.includes(this._options.action);
    }


    private renderServiceButton(service: IService, isAdmin: boolean, hasChildren: boolean) {
        const button = createElement('button', ['fr-accordion__btn', 'service-name', 'name', 'name_service'])
        button.setAttribute('aria-expanded', 'false')
        button.dataset.name = service.name

        if (this._options.action === "administration" && isAdmin) {
            button.classList.add('inactif')
        }
        if (this._options.action === "administration") {
            button.classList.add("service-list-item")
        }

        if (hasChildren) {
            button.setAttribute('data-children', 'true')
            if (!this._options.show_sous_service) {
                button.addEventListener('click', () => {
                    this.handleShowSousService(service.id, this._secteur, this._categorie)
                })
            }
            button.setAttribute('aria-controls', `liste_sous_service_${service.id}`)
        }

        if (this._options.show_old && service?.deja_fait) {
            button.classList.add(`disabled`)
        }

        return button
    }

    private renderServiceLabel(service: IService) {
        const label = createElement("div", ['service-name-block'])
        label.id = `name_container_${service.id}`
        let nameBlock;
        if (this._options.selecteur_multiple) {
            // Vérifier si on doit créer un input
            const shouldCreateInput = !(this._options.action !== "carnet_messagerie" && this._options.show_old && service?.deja_fait);

            const selectBlock = createElement('span')
            const input = createElement('input')
            input.type = "checkbox"
            let value;
            if(this._options.action === "carnet_messagerie" || this._options.action === "multi_select" ){
                value = `${service.id}_${service.service}`
                if (this.value_array.find(object => object.value === `${service.id}_${service.service}`)) input.checked = true
            }
            else {
                value = `${service.id}`
                if (this.value_array.includes(`${service.id}`)) input.checked = true
            }

            if(shouldCreateInput){
                input.name = "service"
                input.value = value
                input.id = `checkbox_${value}`
                input.dataset.service = String(service.id)
                input.dataset.label = service.name
                input.classList.add('large-checkbox')
                selectBlock.appendChild(input)
            }

            label.appendChild(selectBlock)
            stopPropagation(input, 'click')
            input.addEventListener('change', this.handleMultiSelectChange.bind(this))
            nameBlock = createElement('label')
            nameBlock.htmlFor = `checkbox_${value}`
            nameBlock.innerText = service.name
        }
        else {
            nameBlock = createElement('span')
            nameBlock.innerText = service.name
        }

        if (this._options.show_old && service?.deja_fait) {
            const container = createElement('span', ['name'])
            const icon = createIcon('remix-ok')
            container.appendChild(icon)
            label.appendChild(container)
        }
        const iconeBlock = createElement('span')
        if (service.icones) this.renderIcones(iconeBlock, service.icones)
        const agentBlock = createElement('span')

        if (this._options.action === "administration") {
            const adminLink = createElement('a', ['service-list-item'])
            adminLink.href = `#${service.id}`
            adminLink.appendChild(nameBlock)
            adminLink.dataset.service = String(service.id)
            label.appendChild(adminLink)
            adminLink.addEventListener('click', this.handleShowAdministration.bind(this))
        } else {
            label.appendChild(nameBlock)
        }

        if (service.smtp_error) {
            const erreurEmailBlock = createElement('span')
            const icon = createIcon('remix-smtp-erreur', 'Erreur d\'adresse email')
            erreurEmailBlock.appendChild(icon)
            label.appendChild(erreurEmailBlock)
        }
        if (this._options.action === "carnet_messagerie" && service.agents_count?.agents_actif) {
            const container = createElement('span', ['get_agent'])
            const icon = createIcon('remix-utilisateur-neutre')
            container.appendChild(icon)
            label.appendChild(container)
            container.addEventListener('click', this.handleGetAgent.bind(this))
        }

        const agentContainer = createElement('span')
        agentContainer.id = `agent_${service.id}`
        label.appendChild(agentContainer)
        label.appendChild(iconeBlock)
        label.appendChild(iconeBlock)
        label.appendChild(agentBlock)

        if (service.agents_count) this.renderAgentCount(service.agents_count, agentBlock)

        return label
    }

    private renderIcones(parent: HTMLElement, icones: IServiceIcones) {
        Object.entries(icones).forEach(([key, value]) => {
            if (value) {
                let icon
                switch (key) {
                    case 'admin_service_famille_b':
                        icon = "openscop-structure-administrer"
                        break;
                    case 'admin_utilisateurs_subalternes_b':
                        icon = "openscop-utilisateur-administrer"
                        break;
                    case 'porte_entree_avis_b':
                        icon = "remix-recevoir-avis"
                        break;
                    case 'autorise_rendre_avis_b':
                        icon = "remix-rendre-avis"
                        break;
                    case 'autorise_rendre_preavis_a_service_avis_b':
                        icon = "remix-rendre-preavis"
                        break;
                    case 'autorise_mandater_avis_famille_b':
                        icon = "openscop-mandater-avis"
                        break;
                    case 'autorise_interroge_preavis_famille_b':
                        icon = "openscop-interroge-preavis-famille"
                        break;
                }
                if (icon) {
                    const icone = createIcon(icon, null, ['xs'])
                    parent.appendChild(icone)
                }
            }
        })
    }

    private renderAgentCount(agents: any, container: HTMLElement) {
        let icone_class
        let icone_class_0
        let text_tip
        let text_tip_0
        if (agents?.cdsr === 1) {
            icone_class = "remix-structure-neutre"
            icone_class_0 = "remix-cdsr-sans-membres"
            text_tip = "Membres permanents"
            text_tip_0 = "Pas de membre permanent !"
        } else {
            icone_class = "remix-utilisateur-neutre"
            icone_class_0 = "remix-aucun-agent"
            text_tip = "Agents actifs"
            text_tip_0 = "Pas d'agent !"
        }

        if (this._options.action === 'administration' || this._options.action === "gestion-organisation-utilisateur" || this._options.action === "gestion-membre-cdsr") {
            if (agents.agents_inactif) {
                const icon = createIcon(icone_class, "Agents inactifs")
                icon.style.color = '#E13E1B'
                container.appendChild(icon)
            }
            if (agents.agents_actif) {
                const icon = createIcon(icone_class, text_tip)
                icon.style.color = '#015A70'
                container.appendChild(icon)
            }
            if (!agents.agents_actif && !agents.agents_inactif) {
                const icon = createIcon(icone_class_0, text_tip_0)
                container.appendChild(icon)
            }
        } else if (!agents?.agents_actif) {
            const icon = createIcon(icone_class_0, agents.agents_inactif ? 'Pas d\'agent actif !' : text_tip_0)
            container.appendChild(icon)
        }
        initTooltips(container)
    }

    private renderCategorieBadge(secteur: string, categorie: string) {
        const nombre = this.badge_array?.[secteur]?.[categorie] ?? 0
        const parent = $(`${this._options.selecteur_id_reference} li.categorie[data-categorie="${categorie}"]`)
        const id = `badge_${categorie}`
        let badge = $(`${this._options.selecteur_id_reference} #${id}`)
        if (!badge) {
            badge = createElement('span', ['fr-badge', 'd-none'])
            badge.id = id
            parent?.appendChild(badge)
        }
        badge.innerText = nombre
        if (nombre > 0) {
            fadeIn(badge)
        } else {
            fadeOut(badge)
        }
    }

    public resetAllBadges() {
        this.badge_array = {}
        this.value_array = []
        // Sélectionner tous les badges
        const badges = document.querySelectorAll('span.fr-badge');
        // Itérer sur chaque badge
        badges.forEach(badge => {
            // Mettre le texte du badge à 0
            badge.innerText = '0';
            // Faire disparaître le badge
            fadeOut(badge);
        });
    }

    private async listFilter(parametres: ISelecteurListOptions) {
        const secteur = this._secteur
        const categorie = this._categorie
        const action = this._options.action
        if (categorie && secteur) {
            let is_admin = false
            const listeElement = $<HTMLElement>(this._options.selecteurs.listService)
            empty(listeElement)
            fadeOut($(this._options.selecteurs.noResult))
            listeElement?.appendChild(html_chargement_en_cours())
            const listService = $<HTMLInputElement>(this._options.selecteurs.listService)
            this.updateSearchPlaceholder(categorie)
            empty(listService)
            listService?.append(html_chargement_en_cours())
            const instanceSelect = $<HTMLInputElement>(this._options.selecteurs.departementSelectId)
            if (instanceSelect?.value) {
                this._secteur = instanceSelect?.value
            }
            if (action === "gestion-organisation-utilisateur" || action === "administration" || action === "gestion-membre-cdsr") {
                is_admin = await this.userIsAdmin(categorie, secteur)
            }

            $get(window.Openscop.url_service_list, {...parametres, secteur: this._secteur, categorie: this._categorie}).then((response) => {
                this.renderServiceList(response, listeElement, is_admin)
            })
        }
    }

    private renderServiceList(response: ajaxResponse, listeElement: HTMLElement | null, is_admin: boolean) {
        empty(listeElement)
        const secteur = this._secteur
        const categorie = this._categorie
        if (secteur && categorie) {
            if (response.body.length === 0) {
                // pas de service on affiche le no result?
                this.showNoResult()
            }
            for (const service of response.body) {
                const element = this.renderService(service, secteur, categorie, is_admin)
                listeElement?.appendChild(element)
                // Affiche le bouton pour déplier tous les sous-services
                if (!this._options.show_sous_service) {
                    $<HTMLElement>(this._options.selecteurs.toutdeplier)?.classList.remove('d-none')
                }
            }
            // Appel la fonction pour ajouter le bouton de création
            if (this._options.action === "administration" || this._options.action === "rejoindre_orga") {
                this.addBtnCreate(this._options.action)
            }
            if (this._options.selecteur_multiple) {
                fadeIn($(this._options.selecteurs.sendMultiple))
                const btn = $(this._options.selecteurs.toutSelectionner)
                fadeIn(btn)
                toggleSelectionButton(btn)
            } else {
                fadeOut($(this._options.selecteurs.sendMultiple))
                fadeOut($(this._options.selecteurs.toutSelectionner))
            }
        } else {
            this.showNoResult()
        }
    }

    private showNoResult() {
        const noResult = $(this._options.selecteurs.noResult)
        if (noResult) {
            noResult.innerText = this._options.avertissement ?? "Aucun Résultat"
            fadeIn(noResult)
        }
    }

    private updateSearchPlaceholder(categorie: string) {
        // Édite le placeholder de la recherche selon la catégorie
        const searchInput = $<HTMLInputElement>(this._options.selecteurs.searchService)
        if (categorie === "mairie") {
            searchInput?.setAttribute('placeholder', 'Rechercher une mairie')
        } else if (categorie === "structure") {
            searchInput?.setAttribute('placeholder', 'Rechercher une structure')
        } else if (categorie.startsWith('orga')) {
            searchInput?.setAttribute('placeholder', 'Rechercher un organisateur')
        } else if (categorie.startsWith('instructeur')) {
            searchInput?.setAttribute('placeholder', 'Rechercher un instructeur')
        } else {
            searchInput?.setAttribute('placeholder', 'Rechercher un service')
        }
    }

    private addBtnCreate(action: string) {
        const secteur = this._secteur
        const categorie = this._categorie
        const url = "/structure/administration_des_services/is_admin_famille/"
        $get(url, {
            'categorie': categorie,
            'secteur': secteur,
            'action': action,
        }).then((reponse) => {
            const container = $(".container_btn_create")
            empty(container)
            if (reponse.body === "True") {
                // Ajoute un bouton de création de service consulté
                const btn = createElement('button', ['fr-btn', 'fr-col-6', 'fr-mt-5w'])
                btn.id = "open_create_service_form_modal"
                btn.dataset.categorie = categorie
                btn.dataset.instance = secteur
                btn.setAttribute('role', 'button')
                btn.innerHTML = `<i class="remix-ajouter" aria-hidden="true"></i>Ajouter un service`
                btn.addEventListener('click', this.showAddServiceModale.bind(this))
                container?.appendChild(btn)
            } else if (reponse.body === "rejoindre_orga") {
                const btn = createElement('button', ['fr-btn', 'fr-col-6', 'fr-mt-5w'])
                btn.id = "open_create_service_form_modal"
                btn.dataset.categorie = categorie
                btn.dataset.action = action
                btn.dataset.instance = secteur?.split('_')[1]
                btn.setAttribute('role', 'button')
                btn.innerHTML = `<i class="remix-ajouter" aria-hidden="true"></i>Ajouter un service`
                // Ajoute un bouton de création de service consulté
                btn.addEventListener('click', this.showAddServiceModale.bind(this))
                container?.appendChild(btn)
            } else if (reponse.body === "Fédération délégataire") {
                // Affiche une alerte
                const alert = createElement('div', ['fr-alert', 'fr-alert--info'])
                alert.innerHTML = `L'ajout de fédération délégataire est géré par l'équipe Support. Veuillez les contacter via votre forum <a href="/forum/forum-administrateur-instance" class="fr-link">"Administrateurs d'instance
                        départemental"</a>`
                container?.appendChild(alert)
            } else if (reponse.body === "Service instructeur") {
                // Ajoute un bouton de création de service consulté et de service instructeur
                const btnInstructeur = createElement('button', ['fr-btn', 'fr-btn--secondary', 'fr-col-4'])
                btnInstructeur.id = "open_create_service_instructeur_form_modal"
                btnInstructeur.dataset.categorie = categorie
                btnInstructeur.dataset.instance = secteur
                btnInstructeur.setAttribute('role', 'button')
                btnInstructeur.innerHTML = `<i class="remix-ajouter" aria-hidden="true"></i><span>Ajouter un service <strong>instructeur</strong></span>`
                const btnConsulte = createElement('button', ['fr-btn', 'fr-col-6', 'fr-mt-5w'])
                btnConsulte.id = "open_create_service_form_modal"
                btnConsulte.dataset.categorie = categorie
                btnConsulte.dataset.instance = secteur
                btnConsulte.setAttribute('role', 'button')
                btnConsulte.innerHTML = `<i class="remix-ajouter" aria-hidden="true"></i><span>Ajouter un service <strong>consulté</strong></span>`
                container?.appendChild(btnInstructeur)
                container?.appendChild(btnConsulte)
                btnConsulte.addEventListener('click', this.showAddServiceConsulteModale.bind(this))
                btnInstructeur.addEventListener('click', this.showAddServiceInstructeurModale.bind(this))
            }
        })
    }

    private createBtn(service: IService, isPrimary = true) {
        const btn = createElement('button', ['fr-btn', 'fr-btn--sm'])
        btn.dataset.service = String(service.id)
        let icon = createElement('i')
        if (isPrimary) {
            btn.classList.add('btn-action-selecteur')
            btn.innerHTML = "<i class='remix-ok'></i> Envoyer"
        } else {
            icon.classList.add('remix-pas-ok')
            btn.classList.add('fr-btn--secondary', 'dismiss')
        }
        icon.setAttribute('aria-hidden', 'true')
        btn.appendChild(icon)
        return btn
    }

    private userIsAdmin(categorie: string | undefined, secteur: string | undefined): Promise<boolean> {
        return new Promise(resolve => {
            if (secteur && categorie && categorie !== "structure") {
                const url = "/structure/administration_des_services/is_admin_famille/"
                $get(url, {
                    categorie,
                    secteur,
                }).then((reponse) => {
                    if (reponse.body === "True") {
                        resolve(true)
                    } else {
                        resolve(false)
                    }
                })
            } else resolve(false)
        })
    }

    private handleUpdateSecteur(event: DOMEvent<HTMLSelectElement>) {
        const options = this._options
        const departementSelect = event.target
        const selected = departementSelect.value
        this._secteur = selected
        $<HTMLInputElement>(this._options.selecteurs.searchService)!.value = ""
        $(options.selecteurs.categoriesList)?.classList.remove('d-none')
        // Modifie la liste des catégories selon le secteur sélectionné
        if (options.action !== "ajouter_invite") {
            if (selected.split("_")[0] !== "instance") {
                if (selected === "national") {
                    this.renderListCategorie({
                        action: "get_national",
                        ajout: this._options.ajout,
                        object_id: this._options.object_id,
                    })
                }
                if (selected.split("_")[0] === "region") {
                    this.renderListCategorie({
                        action: "get_regional",
                        ajout: this._options.ajout,
                        object_id: this._options.object_id,
                    })
                }
            } else {
                this.renderListCategorie({
                    action: this._options.action,
                    ajout: this._options.ajout,
                    object_id: this._options.object_id,
                })
            }
        }
        const categoriesElements = $$<HTMLElement>(options.selecteurs.categorieElements)
        if (categoriesElements.length === 1) {
            categoriesElements.forEach(categorie => categorie.classList.add('selected'))
        }

        const selectedCategories = $$<HTMLElement>(options.selecteurs.selectedCategorieElements)
        if (selectedCategories.length > 0) {
            selectedCategories.forEach(categorie => this._categorie = categorie.dataset?.categorie)
        }
        if (this._categorie) {
            // Filtre la liste si une categorie est selectionné
            $<HTMLElement>(`${this._options.selecteur_id_reference} li[data-categorie="${this._categorie}"]`)?.classList.add('selected')
            this.listFilter({
                object_id: this._options.object_id,
                action: this._options.action,
                show_agent: this._options.show_agent,
                show_old: this._options.show_old,
                show_sous_service: this._options.show_sous_service,
                manif: this._options.manif,
            })
        }
    }

    private handleCategorieClick(event: DOMEvent<HTMLElement>) {
        $<HTMLInputElement>(this._options.selecteurs.searchService)!.value = ""
        // $<HTMLInputElement>(this._options.selecteurs.searchService)!.blur();
        const categorieElement = event.target
        this._categorie = categorieElement.dataset.categorie
        const listService = $(this._options.selecteurs.containerListService)
        if (listService?.classList.contains('d-none')) fadeIn(listService)
        this.listFilter({
            object_id: this._options.object_id,
            action: this._options.action,
            show_agent: this._options.show_agent,
            show_old: this._options.show_old,
            show_sous_service: this._options.show_sous_service,
            manif: this._options.manif,
        })
        $(this._options.selecteurs.selectedCategorieElements)?.classList.remove('selected')
        categorieElement.classList.add('selected')
    }

    private handleShowSousService(serviceId: number, secteur: string | undefined, category: string | undefined) {
        if (secteur && category) {
            const target = $(`#liste_sous_service_${serviceId}`)
            const url = `/structure/ajax/sous_service/`
            $get(url, {
                'service_id': serviceId,
                'action': this._options.action,
                'show_old': this._options.show_old,
                'object_id': this._options.object_id,
            }).then(async (reponse) => {
                empty(target)
                for (let element of reponse.body) {
                    target?.appendChild(this.renderService(element, secteur, category))
                }
            })
        }
    }

    private handleToutDeplier() {
        if (!this._options.show_sous_service) {
            this.tout_deplier = !this.tout_deplier
            const services = $(this._options.selecteurs.listService)
            if (services) {
                $$(`.fr-accordion__btn[aria-expanded="${!this.tout_deplier}"]`, services).forEach(el => {
                    el.click()
                })
            }
        }
    }

    private handleSelectionnerTout(event: DOMEvent<HTMLButtonElement>) {
        const target = getParentElementByClassName(event.target, 'select-all-button')
        const services = $(this._options.selecteurs.listService)
        if (services && target) {
            $$<HTMLInputElement>(`[name="service"]`, services).forEach(el => {
                if (target.dataset.selected === "false") {
                    if (!el.checked) el.click()
                } else {
                    if (el.checked) el.click()
                }
            })
        }
        toggleSelectionButton($(this._options.selecteurs.toutSelectionner))
    }

    private handleActionBtnClick(event: DOMEvent<HTMLElement>) {
        event.stopPropagation()
        const target = getParentElementByTagName(event.target, 'button')
        const id = target?.dataset?.service
        // Appel une url d'action si elle est fournie
        if (this._options.urls.url_selecteur_action && target && id) {
            if (this._options.action === 'ajouter_invite') {
                this.envoieDemandeAvis(id, target)
            } else if (this._options.action === "gestion-organisation-utilisateur" || this._options.action === "rejoindre_orga") {
                this.addOrganisationUser(id, target)
            } else if (this._options.action === "gestion-membre-cdsr") {
                this.addOrganisationUser(id, target)
            }
        }
        // Sinon remplie les données d'un formulaire
        else {
            if (id) {
                $<HTMLInputElement>('#id_service')!.value = id
            }
            $("#span-service-selectione")!.textContent = $("#name_container_" + id)!.querySelector("span")!.textContent
            hideModal("selection")
        }
    }

    private handleSearchUpdate() {
        const search = $<HTMLInputElement>(this._options.selecteurs.searchService)!.value
        if (search.length === 0) {
            $$('.name_service').forEach(service => {
                fadeIn(service)
                service.classList.remove('animate__fadeOut');
                service.parentElement!.parentElement!.classList.remove('selecteur-search-result', 'no-box-shadow-before');
            })
        } else {
            if ($$('.name_service').length > 0) {
                $$('.name_service').forEach(service => {
                    if (!service.dataset.name?.toLowerCase().includes(search.toLowerCase())) {
                        fadeOut(service)
                        service.classList.add('d-none')
                        service.classList.add('animate__fadeOut');
                        service!.parentElement!.parentElement!.classList.remove('selecteur-search-result');
                        service!.parentElement!.parentElement!.classList.add('no-box-shadow-before');
                    } else {
                        fadeIn(service)
                        service.classList.remove('animate__fadeOut');
                        service!.parentElement!.parentElement!.classList.add('selecteur-search-result');
                        service!.parentElement!.parentElement!.classList.remove('no-box-shadow-before');
                    }
                })
            }
            if ($$('.selecteur-search-result').length === 0){
                this.showNoResult()
            }
            else {
                $(this._options.selecteurs.noResult)!.classList.add('d-none')
            }
        }
    }

    private handleSearchFocus() {
        // on ouvre tous les services :
        if (!this.tout_deplier) this.handleToutDeplier()
    }

    private handleMultiSelectChange(event: DOMEvent<HTMLInputElement>) {
        const target = getParentElementByClassName(event.target, 'fr-accordion')
        const input = event.target
        const type = input.name
        const selected = input.checked
        const label = input.dataset.label
        const secteur = target?.dataset.secteur
        const categorie = target?.dataset.categorie

        if (secteur && categorie) {
            if (!this.badge_array[secteur]) {
                this.badge_array[secteur] = {}
            }
            if (!this.badge_array[secteur][categorie]) {
                this.badge_array[secteur][categorie] = 0
            }
            if(this.options.action === "carnet_messagerie" || this._options.action === "multi_select"){
                if (selected) {
                    this.value_array.push({
                        text: label,
                        selected: true,
                        value: input.value,
                    })
                    this.badge_array[secteur][categorie] += 1
                } else {
                    this.value_array = this.value_array.filter(val => val.value !== input.value)
                    this.badge_array[secteur][categorie] -= 1
                }
            }
            else {
                if (selected) {
                    this.value_array.push(input.value)
                    this.badge_array[secteur][categorie] += 1
                } else {
                    this.value_array = this.value_array.filter(value => value !== input.value);
                    this.badge_array[secteur][categorie] -= 1
                }
            }

            if (type === 'service') this.toggleAllAgents(target, selected, secteur, categorie)
            this.renderCategorieBadge(secteur, categorie)
        }

        if (this.options.action === "multi_select") {
            const select = $<HTMLSelectElement>('#id_liste_des_services_concerne_m2m')?.slim
            if (select) {
                let selectedElements = select.getSelected()
                if (input.checked) {
                    selectedElements.push(input.dataset.service)
                } else {
                    selectedElements = selectedElements.filter(val => val !== input.dataset.service)
                }
                select.setSelected(selectedElements)
            }
        }
    }

    private handleGetAgent(event: DOMEvent<HTMLElement>) {
        event.stopPropagation()
        const target = getParentElementByClassName(event.target, 'get_agent')
        const source = getParentElementByTagName(event.target, 'section')
        const service_id = source?.dataset.service
        const resultContainer = $<HTMLElement>(`#agent_${service_id}`)
        empty(resultContainer)
        const parentIsChecked = $<HTMLInputElement>(`#checkbox_${service_id}_Organisation`)?.checked ?? false

        if (!target?.classList.contains('active')) {
            $get(this._options.urls.url_get_agents, {
                'object_id': service_id,
            }).then((response) => {
                const agentContainer = createElement('div', ['agent_list'])
                const data = Object.entries(response.body) as [string, string[]][]
                target?.classList.add('active')
                for (const [key, value] of data) {
                    const agentLine = createElement('div', ['agent'])
                    const input = createElement('input')
                    input.type = "checkbox"
                    input.id = `${key}_${value[1]}`
                    input.value = `${key}_${value[1]}`
                    input.name = `agent`
                    input.dataset.label = `${value[0]}`
                    input.dataset.service = `${key}_${value[1]}`
                    input.checked = parentIsChecked
                    if (parentIsChecked) input.disabled = true
                    input.addEventListener('change', this.handleMultiSelectChange.bind(this))
                    if (this.value_array.find(item => item.value === value[1])) input.checked = true
                    const label = createElement('label', ['name_sous_service', 'name', 'label'])
                    label.setAttribute('for', `${key}_${value[1]}`)
                    label.innerText = `${value[0]}`
                    agentLine.appendChild(input)
                    agentLine.appendChild(label)
                    agentContainer.appendChild(agentLine)
                }
                if (data.length === 0) {
                    agentContainer.classList.add('text-alert')
                    agentContainer.innerHTML = `<strong>Pas d'agent trouvé</strong>`

                }
                resultContainer?.appendChild(agentContainer)
            })
        } else {
            target?.classList.remove('active')
        }
    }
    private envoieDemandeAvis(item_id: string, item: HTMLElement) {
        empty(item)
        const spinner = createSpinner('xs')
        item?.appendChild(spinner)

        $get(this._options.urls.url_selecteur_action, {
            'array_id[]': item_id,
            'instruction_id': this._options.object_id,
        }).then((reponse) => {
            let result = createElement('span', ['d-none'])
            result.style.fontWeight = 'bold'
            // container.animate({paddingLeft: '0'}, 800)
            if (reponse.body === "True") {
                this.demande_envoye = true
                result.innerText = "Demande envoyée"
                result.style.color = "#869200"
            } else {
                let texte = "Un problème est survenu";
                if (reponse.body !== "False") {
                    texte = reponse.body;
                }
                result.innerText = texte
                result.classList.add('btn-action-selecteur')
            }
            item.appendChild(result)
            fadeOutFadeIn(spinner, result)
        })
    }

    private envoieMultipleDemandesAvis(items_id, target) {
        empty(target)
        const spinner = createSpinner('xs')
        target?.appendChild(spinner)
        // Convert the array items to integers if necessary
        let formattedItems = items_id.map(item => parseInt(item, 10));

        // Create the query parameters
        let params = new URLSearchParams();
        formattedItems.forEach(id => {
            params.append('array_id[]', id);
        });
        params.append('instruction_id', this._options.object_id);

        // Convert the params object to a string for the GET request
        let queryString = params.toString();

        // Appel de l'url de création d'avis
        $get(`${this._options.urls.url_selecteur_action}?${queryString}`).then((reponse) => {
            let alert = createElement('div', ['fr-alert', 'alert-dismissable'])
            let list_container = $(`${this._options.selecteur_id_reference} .service-liste`)
            if (reponse.body === "True") {
                this.demande_envoye = true
            } else {
                let texte = "Un problème est survenu";
                // Créer le bouton
                const closeButton = document.createElement('button');
                closeButton.className = 'fr-btn--close fr-btn';
                closeButton.setAttribute('aria-label', 'Masquer le message');
                closeButton.setAttribute('onclick', 'const alert = this.parentNode; alert.parentNode.removeChild(alert)');
                closeButton.textContent = 'Masquer le message';
                // Créer le message d'alerte
                let alert_message = document.createElement('p');
                // Vérifier si des services non envoyés sont présents dans la réponse
                if (reponse.body.service_non_envoye) {
                    texte = "Une erreur est survenue lors de l'envoi de l'avis vers les services :";
                    alert_message.textContent = texte;
                    let serviceList = document.createElement('ul');
                    reponse.body.service_non_envoye.forEach((service: string) => {
                        let listItem = document.createElement('li');
                        listItem.textContent = service;
                        serviceList.appendChild(listItem);
                    });
                    alert.appendChild(alert_message);
                    alert.appendChild(serviceList);
                } else {
                    if (reponse.body !== "False") {
                        texte = reponse.body;
                    }
                    alert_message.textContent = texte;
                    alert.appendChild(alert_message);
                }
                alert.appendChild(closeButton);
                alert.classList.add('fr-alert--error');
                list_container?.prepend(alert);
            }
            this.resetAllBadges()
            this.listFilter({
                object_id: this._options.object_id,
                action: this._options.action,
                show_agent: this._options.show_agent,
                show_old: this._options.show_old,
                show_sous_service: this._options.show_sous_service,
                manif: this._options.manif,
            })
            target.textContent  = "Valider"
            fadeOutFadeIn(spinner, target)
        })
    }

    private multiAccesConsultation(items_id, target) {
        // Définition de la modale permettant d'enregistrer le motif de l'octroi de l'accès en lecture
        createAcessConsultationModale()
        empty(target)
        const spinner = createSpinner('xs')
        target?.appendChild(spinner)
        // on enregistre le message détaillant le motif de l'octroi de l'accès en lecture
        $<HTMLButtonElement>('#enregistrer_motif_octroi_acces_lecture')?.addEventListener('click', () => {
            const motif_octroi_acces_lecture = $<HTMLTextAreaElement>('#motif_octroi_acces_lecture')?.value
            // si le message n'est pas vide
            if (motif_octroi_acces_lecture && motif_octroi_acces_lecture.trim() !== "") {
                // const {spinner} = animateLoadingButton(item)!
                const formData = new FormData()
                items_id.forEach(id => {
                    formData.append('service_id[]', id);
                });
                if (this._options.ajout) formData.append('acces', this._options.ajout)
                // if (model) formData.append('model', model)
                formData.append('motif_octroi_acces_lecture', motif_octroi_acces_lecture)
                hideModal('selecteur-access-consultation-modal')
                $postForm(this._options.urls.url_selecteur_action, formData).then((reponse) => {
                    let list_container = $(`${this._options.selecteur_id_reference} .service-liste`)
                    let alert = createElement('div', ['fr-alert', 'alert-dismissable'])

                    if (reponse.body === "True") {
                        this.demande_envoye = true
                        this.resetAllBadges()
                        this.listFilter({
                            object_id: this._options.object_id,
                            action: this._options.action,
                            show_agent: this._options.show_agent,
                            show_old: this._options.show_old,
                            show_sous_service: this._options.show_sous_service,
                            manif: this._options.manif,
                        }).then(() => {
                            // Créer le message d'alerte
                            list_container = $(`#selecteur-list-${this._options.action}-${this._options.ajout}`)
                            const closeButton = document.createElement('button');
                            closeButton.className = 'fr-btn--close fr-btn';
                            closeButton.setAttribute('aria-label', 'Masquer le message');
                            closeButton.setAttribute('onclick', 'const alert = this.parentNode; alert.parentNode.removeChild(alert)');
                            closeButton.textContent = 'Masquer le message';
                            let alert_message = document.createElement('p');
                            alert_message.textContent = "Accès en lecture octroyé(s)";
                            alert.appendChild(alert_message);
                            alert.classList.add('fr-alert--success');
                            alert.appendChild(closeButton);
                            list_container?.prepend(alert);
                        });
                    } else {
                        let texte = "Un problème est survenu";
                        // Créer le bouton
                        const closeButton = document.createElement('button');
                        closeButton.className = 'fr-btn--close fr-btn';
                        closeButton.setAttribute('aria-label', 'Masquer le message');
                        closeButton.setAttribute('onclick', 'const alert = this.parentNode; alert.parentNode.removeChild(alert)');
                        closeButton.textContent = 'Masquer le message';

                        // Créer le message d'alerte
                        let alert_message = document.createElement('p');

                        // Vérifier si l'erreur est un objet contenant des services et des messages d'erreur
                        if (typeof reponse.body === 'object' && !Array.isArray(reponse.body) && reponse.body !== null) {
                            texte = "Une erreur est survenue lors de l'octroie d'accès en lecture vers les services :";
                            alert_message.textContent = texte;
                            let serviceList = document.createElement('ul');

                            for (let service in reponse.body) {
                                if (reponse.body.hasOwnProperty(service)) {
                                    let listItem = document.createElement('li');
                                    listItem.textContent = `${service} : ${reponse.body[service]}`;
                                    serviceList.appendChild(listItem);
                                }
                            }
                            alert.appendChild(alert_message);
                            alert.appendChild(serviceList);
                        } else {
                            if (reponse.body !== "False") {
                                texte = reponse.body;
                            }
                            alert_message.textContent = texte;
                            alert.appendChild(alert_message);
                        }

                        alert.appendChild(closeButton);
                        alert.classList.add('fr-alert--error');
                        list_container?.prepend(alert);
                    }

                    target.textContent  = "Valider"
                    fadeOutFadeIn(spinner, target)
                })
            } else {
                alert('Vous devez donner un motif pour pouvoir octroyer un accès en lecture. Ce dernier n\'a donc pas encore été octroyé, veuillez recommencer.')
            }
        });
    }

    private addOrganisationUser(service_id: string, item: HTMLElement) {
        animateLoadingButton(item, 'En cours...')!
        const url_action = this.options.urls.url_selecteur_action
        if (url_action) {
            $get(url_action, {
                'service_id': service_id,
                'array_id[]': service_id,
                'user_id': this._options.object_id,
            }).then((reponse) => {
                if (reponse.body === "True") {
                    this.demande_envoye = true
                    item.innerHTML = `<p><b>Organisation ajoutée</b></p>`
                } else {
                    item.innerHTML = `<p><b>${reponse.body}</b></p>`
                }
            })
        }
    }

    private handleSubmitData(event) {
        if (this._options.action === "carnet_messagerie") {
            fadeIn($('#service_instru'))
            hideModal("carnet_messagerie")
            $<HTMLSelectElement>("#destinataire_liste")?.slim?.setData(this.value_array)
        }
        else if (this._options.action === "demande_avis") {
            this.envoieMultipleDemandesAvis(this.value_array, event.target)
        }
        else if (this._options.action === "consultation") {
            this.multiAccesConsultation(this.value_array, event.target)
        }
        else if (this._options.action === "multi_select") {
            const event = new CustomEvent('selecteur:multiple', {
                detail: this.value_array
            })
            this.dispatchEvent(event)
        }
    }

    private toggleAllAgents(service: HTMLElement, selected: boolean, secteur: string, categorie: string) {
        const agentList = $$<HTMLInputElement>(`h3 .agent > input`, service)
        agentList.forEach(agent => {
            // on supprime l'id des valeurs
            if (this.value_array.find(value => value.value === agent.value)) {
                this.value_array = this.value_array.filter(value => value.value !== agent.value)
                this.badge_array[secteur][categorie] -= 1
            }
            agent.checked = selected
            agent.disabled = selected
        })
    }

    private showAddServiceModale(event: DOMEvent<HTMLElement>) {
        const target = getParentElementByTagName(event.target, 'button')
        if (target) {
            const categorie = target.dataset.categorie!
            const instance = target.dataset.instance
            let url = `/structure/create_service_consulte/`
            if (categorie === "structure") {
                url = `/structure/create_structure_organisatrice/`
            } else if (categorie === "12") {
                url = `/structure/create_federation/`
            }
            $get(url, {categorie, instance}).then((response) => {
                const container = createElement('div')
                container.innerHTML = response.body
                generateModale('add-service-modal', {
                    title: 'Ajouter un service',
                    content: container,
                    title_in_header: true,
                })

                initAddServiceModal('add-service-modal', instance === "national", categorie)
            })
        }
    }

    private handleShowAdministration(event: DOMEvent<HTMLElement>) {
        event.preventDefault()
        const item = getParentElementByTagName(event.target, 'a') as HTMLAnchorElement
        const object_id = new URL(item.href).hash.slice(1);
        const service_id = item?.dataset.service;
        const is_user = item?.classList.contains('organisation_user')
        const container = $('#service_selectionne')
        if (service_id) {
            if (container) {
                empty(container)
                container.append(html_chargement_en_cours("Chargement en cours", ['blocs-chargement-spinner', 'fr-alert', 'fr-alert--info', 'fr-mt-4w', 'fr-py-2w']))
            }
            let url
            if (is_user) {
                history.pushState(null, '', `?service_id=${service_id}&user_id=${object_id}`);
                url = this._options.urls.url_user_detail
            } else {
                history.pushState(null, '', `?service_id=${object_id}`);
                url = this._options.urls.url_selecteur_action
            }
            $get(url, {
                'administration': true,
                'object_id': object_id,
                'organisation_id': service_id
            }).then((data) => {
                if (container) {
                    empty(container)
                    container.innerHTML = data.body
                    initSelects(container)
                    initTooltips(container)
                    initHistoryModal(container)
                    this.dispatchEvent(new CustomEvent('showAdministrationService'))
                }
            }).catch(() => {
                if (container) {
                    empty(container)
                    container.innerHTML = `<div class='fr-alert fr-alert--warning fr-py-4w'>Vous n'êtes pas habilité à voir ces informations.</div>`
                }
            })
        }
    }

    private showAddServiceConsulteModale(event: DOMEvent<HTMLElement>) {
        const target = getParentElementByTagName(event.target, 'button')
        if (target) {
            const categorie = target.dataset.categorie!
            const instance = target.dataset.instance
            let url = `/structure/create_service_consulte/`
            if (categorie === "structure") {
                url = `/structure/create_structure_organisatrice/`
            } else if (categorie === "12") {
                url = `/structure/create_federation/`
            }
            $get(url, {categorie, instance}).then((response) => {
                const container = createElement('div')
                container.innerHTML = response.body
                generateModale('add-service-consulte', {
                    title: 'Ajouter un service',
                    content: container,
                    title_in_header: true,
                })

                initAddServiceModal('add-service-consulte', instance === "national", categorie)
            })
        }
    }

    private showAddServiceInstructeurModale(event: DOMEvent<HTMLElement>) {
        const target = getParentElementByTagName(event.target, 'button')
        if (target) {
            const categorie = target.dataset.categorie!
            const instance = target.dataset.instance

            let url = `/structure/create_service_instructeur/`
            $get(url, {categorie, instance}).then((response) => {
                const container = createElement('div')
                container.innerHTML = response.body
                generateModale('add-service-instructeur', {
                    title: 'Ajouter un service',
                    content: container,
                    title_in_header: true
                })

                initAddServiceModal('add-service-instructeur', instance === "national", categorie)
            })
        }
    }
}

function createAcessConsultationModale() {
    // <textarea rows="6" cols="55" id="motif_octroi_acces_lecture"></textarea>
    const textarea = createElement('div', ['fr-input-group', 'fr-p-2w'])
    textarea.innerHTML = `
    <label class="fr-label" for="motif_octroi_acces_lecture">
        Raison :
    </label>
    <textarea
            class="fr-input"
            id="motif_octroi_acces_lecture"
            name="motif_octroi_acces_lecture"
            rows="6"
            cols="55"
    ></textarea>`

    const btn = createElement('button', ['fr-btn'])
    btn.id = "enregistrer_motif_octroi_acces_lecture"
    btn.innerText = "Enregistrer"

    return generateModale('selecteur-access-consultation-modal', {
        title: 'Veuillez en détailler la raison',
        content: textarea,
        actions: [
            btn
        ],
    })
}


function toggleSelectionButton(btn: HTMLElement | null) {
    if (btn) {
        const isSelected = $$("#service-liste input:checked").length > 0
        btn.innerText = isSelected ? "Désélectionner tout" : "Sélectionner tout"
        btn.dataset.selected = isSelected ? "true" : "false"
    }
}